import { all } from 'redux-saga/effects';

import { fetchAssessmentReportsSaga } from './fetchAssessmentReports';

export function* saga() {
    yield all([fetchAssessmentReportsSaga()]);
}
